// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';
import NotificationSettingsClient from '../../models/companies/NotificationSettingsClient';
import { handleAxiosError } from '../../helpers/axiosHelper';
import flashMessage from '../../utils/flashMessage';

export default class NotificationSettingView extends JQueryView {
  companyId: number;

  notificationSettingsClient = new NotificationSettingsClient();

  constructor(companyId: number) {
    super('#setting-modal');

    this.companyId = companyId;
  }

  @on({ event: 'click', selector: '#mail-switch' })
  onClickSetting(event: any) {
    const receivable = $(event.target).prop('checked');
    this.notificationSettingsClient
      .updateSetting('receive_delegate_and_agreement_copy_notice', receivable)
      .catch(error => handleAxiosError(error, flashMessage));
  }
}
